<template>
  <div class="trial-sugeons-list">
    <Breadcrumbs :items="breadcrumbs" />
    <rp-trialsurgeontable
      :trialSurgeons="trialSurgeons"
      @onView="onView" />
  </div>
</template>

<script>
import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import TrialSurgeonTable from 'raypro_ui/src/components/ui/TrialSurgeonTable'
import {getAllTrialSurgeons} from 'raypro_ui/src/api/trials'

export default {
  mixins: [page],

  components: {
    'rp-button': Button,
    'rp-trialsurgeontable': TrialSurgeonTable,
    Breadcrumbs
  },

  data() {
    return {
      trialSurgeons: [],
      title: 'Search Surgeon',
      breadcrumbs: [
        {label: 'Search Surgeon'}
      ]
    }
  },

  computed: {
  },

  async mounted() {
    await this.getTrialSurgeons()
  },

  methods: {
    async getTrialSurgeons() {
      let {data} = await getAllTrialSurgeons()
      this.trialSurgeons = data
    },

    onView(row) {
      this.$router.push({name: 'view-surgeon-trials', params: {id: row.id}})
    },
  },
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
</style>



// WEBPACK FOOTER //
// src/components/pages/Clinical/TrialSurgeons.vue